// @flow
import * as React from 'react';
import LeftSidebarLink from './LeftSidebarLink';

import type { Props } from './LeftSidebarLink';

function defaultNavLinkRenderer(props: Props): React.Node {
    return <LeftSidebarLink {...props} />;
}

export default defaultNavLinkRenderer;
